/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconIceCream = createReactComponent("ice-cream", "IconIceCream", [
  ["path", { d: "M12 21.5v-4.5", key: "svg-0" }],
  ["path", { d: "M8 17h8v-10a4 4 0 1 0 -8 0v10z", key: "svg-1" }],
  ["path", { d: "M8 10.5l8 -3.5", key: "svg-2" }],
  ["path", { d: "M8 14.5l8 -3.5", key: "svg-3" }]
]);

export { IconIceCream as default };
//# sourceMappingURL=IconIceCream.js.map
